// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2MDu-","selected":"Chip_selected__v6Cn-"};